<template>
  <div class="ua-pdp">
    <!-- Loading -->
    <template v-if="fetching">
      <span style="display: none">商品加载中</span>
    </template>

    <!-- Product is available -->
    <template v-else-if="product.isAvailable">
      <!-- 面包屑 (仅移动端可见) -->
      <PdtBreadcrumd
        v-if="!isMobile"
        :light-mode="
          ((isMobile && product.topPic) || product.pcTopPic) && !product.isDisplayedTopBanner
        "
      />

      <!-- Top Image -->
      <PdtTopBanner :key="product.productNo" />

      <!-- Shortcut -->
      <PdtShortcut ref="shortcut" />

      <!-- Content -->
      <div class="ua-pdp-content">
        <PdtAnchorSection title="产品图" name="pdp-pdtimages">
          <!-- 仅作为锚点使用 -->
          <pdt-section headless title="产品图" name="pdp-pdtimages" hidden />

          <!-- 图片 & 销售属性 MOBILE -->
          <section
            v-if="isMobile"
            class="pdp-track-container"
            frame_name="顶部商品参数区"
            style="position: relative"
          >
            <PdtMediaMob />
            <PdtSaleAttrsMob @onTrackDetailOperate="trackDetailOperate" />
          </section>

          <!-- 图片 & 销售属性 PC -->
          <section v-else class="pdp-track-container" frame_name="顶部商品参数区">
            <div class="ua-pdp-pc-top-container">
              <section class="ua-pdp-pc-imgs">
                <PdtMediaPc />
              </section>

              <!-- 商品可用 -->
              <section class="ua-pdp-pc-sale-attrs">
                <PdtSaleAttrsPc @onTrackDetailOperate="trackDetailOperate" />
              </section>
            </div>
          </section>
        </PdtAnchorSection>

        <!-- 详情 & Bottom -->
        <template v-if="!product.isOutofSale">
          <PdtAnchorSection title="商品详情" short-title="详情" name="pdp-details">
            <!-- 商品详情 -->
            <pdt-section
              v-if="!!product.fullDescription"
              title="商品详情"
              short-title="详情"
              name="pdp-details"
              class="pdp-track-container"
              frame_name="中部商品图片展示区"
            >
              <PdtDescription />
            </pdt-section>
            <!-- 商品信息 -->
            <pdt-section
              v-if="
                isMobile &&
                product &&
                product.productInfoItems &&
                product.productInfoItems.some(i => i.list && i.list.some(i => i))
              "
              title="商品信息"
              class="pdp-track-container"
              frame_name="中部商品文字介绍区"
            >
              <PdtAttrList :list="product.productInfoItems || []" />
            </pdt-section>
          </PdtAnchorSection>

          <PdtAnchorSection title="搭配推荐" short-title="搭配" name="pdp-set">
            <!-- 推荐搭配 -->
            <pdt-section
              v-if="!!(product.relationPdts && product.relationPdts.list.length)"
              title="搭配推荐"
              short-title="搭配"
              name="pdp-set"
              style="overflow: visible"
              class="pdp-track-container"
              frame_name="中部商品推荐搭配区"
            >
              <PdtSet />
            </pdt-section>

            <!-- 试穿报告 -->
            <pdt-section
              v-if="product.isHasSizeReport"
              title="试穿报告"
              class="pdp-track-container"
              frame_name="中部商品试穿报告区"
            >
              <PdtSizeReport />
            </pdt-section>

            <!-- 尺码建议 -->
            <pdt-section
              v-if="isMobile"
              class="pdp-track-container"
              frame_name="中部商品尺码区"
              title="尺码建议"
              toggleable
            >
              <SizeInfo inline-view-mode :attributes="product.attributes" />
            </pdt-section>

            <!-- 购物须知 -->
            <pdt-section
              v-if="isMobile"
              title="购物须知"
              class="pdp-track-container"
              frame_name="底部商品文字介绍区"
            >
              <PdtAttrList :max="2" :list="product.buyNoticeJSON" :liststyleness="false" />
            </pdt-section>
            <!-- 广告 -->
            <pdt-section
              :class="{
                'pdp-track-container': true,
                'ua-pdp-topAd-container__mobile': isMobile
              }"
              title=""
            >
              <topAd
                v-if="topAd.length"
                :key="$route.path"
                class="count-topAd-class ua-pdp-topAd-container"
                :data="topAd"
              ></topAd>
            </pdt-section>
          </PdtAnchorSection>

          <PdtAnchorSection title="猜你喜欢" short-title="推荐" name="pdp-guess-ulike">
            <!-- 商品推荐 -->
            <no-ssr>
              <pdt-section
                v-if="!product.isHasPerHotActivity"
                :key="product.mainProductNo"
                headless
                title="猜你喜欢"
                short-title="推荐"
                name="pdp-guess-ulike"
                class="ua-pdp-btm-block pdp-track-container"
                frame_name="底部人气商品商品列表区"
              >
                <PdtRecommand />
              </pdt-section>
            </no-ssr>
          </PdtAnchorSection>
        </template>
      </div>
    </template>

    <!-- Product not found -->
    <template v-else>
      <div class="ua-pdp-content">
        <PdtNotFound />
      </div>
    </template>
  </div>
</template>

<script>
import { GtMessage } from '@speedshop/template';
import { useProduct } from '@speedshop/sdk-api';
import { mapGetters, mapState } from 'vuex';
import lo from 'lodash';
import PdtMediaPc from './components/PdtMediaPc.vue';
import PdtMediaMob from './components/PdtMediaMob.vue';
import PdtSaleAttrsPc from './components/PdtSaleAttrsPc.vue';
import PdtSaleAttrsMob from './components/PdtSaleAttrsMob.vue';
import PdtSet from './components/PdtSet.vue';
import PdtSizeReport from './components/PdtSizeReport.vue';
import PdtRecommand from './components/PdtRecommand.vue';
import PdtDescription from './components/PdtDescription.vue';
import PdtShortcut from './components/PdtShortcut.vue';
import PdtSection from './components/PdtSection.vue';
import PdtAnchorSection from './components/PdtAnchorSection.vue';
import PdtTopBanner from './components/PdtTopBanner.vue';
import { getProductDetails } from './lib/logic';
import PdtBreadcrumd from './components/PdtBreadcrumd.vue';
import PdtAttrList from './components/PdtAttrList.vue';
import PdtNotFound from './components/PdtNotFound.vue';
import { headFactor, getUserInfo } from './lib/utils';
import { businessCodes } from './lib/constant';
import { addToCart } from '@/graphql/plp.gql';
import { useUaShopCart } from '@/utils/cart.js';
import { getProduct } from '@/utils/product';
import SizeInfo from '@/components/PDP/SizeInfo.vue';
import topAd from '@/components/LandingPage/topAd.vue';

export default {
  name: 'PDP',

  components: {
    PdtMediaPc,
    PdtDescription,
    PdtSet,
    PdtRecommand,
    PdtSizeReport,
    PdtSaleAttrsPc,
    PdtSaleAttrsMob,
    PdtSection,
    PdtAnchorSection,
    PdtBreadcrumd,
    PdtMediaMob,
    PdtAttrList,
    SizeInfo,
    PdtShortcut,
    PdtTopBanner,
    PdtNotFound,
    topAd
  },

  provide() {
    return {
      pdp: this
    };
  },

  async asyncData({ route }) {
    try {
      const { params: { code: productCode } = {}, qeury: { activityCode, activityType } = {} } =
        route;
      const product = await getProductDetails({
        productCode,
        activityCode,
        activityType,
        statusAll: true,
        withRecommend: false,
        disabledSoldOut: true
      });
      return { product, fetching: false };
    } catch (e) {
      console.error(e);
      return { product: {}, fetching: false };
    }
  },

  data() {
    return {
      // 是否加载过穿搭推荐
      lazyLoadFitRecommendFetched: false,
      // 商品加载中
      fetching: true,

      // 商品信息
      product: {},

      // 订阅信息 是一个以productCode 或者skuCode为key, 以是否订阅为value 的 map
      subscription: {
        // 库存订阅
        stock: {},
        // 发售订阅
        sale: {}
      }
    };
  },

  head() {
    return headFactor(this.product || { productName: '商品详情' });
  },

  computed: {
    ...mapGetters(['isMobile', 'isGuest', 'isLogin']),
    ...mapState(['adData']),
    userInfo() {
      return this.$store.state.accountInfo || {};
    },
    isCrm() {
      return !!this.$store.state.accountInfo.protocolFlag;
    },
    topAd() {
      const { PageBannerWithPosition } = this.adData || {};
      const { top } = PageBannerWithPosition || {};
      return top || [];
    }
  },
  watch: {
    'product.mainProductNo': {
      immediate: true,
      handler() {
        // category
        this.queryCategories();
      }
    }
  },

  mounted() {
    // const { params: { code: productCode } = {}, qeury: { activityCode, activityType } = {} } =
    //   this.$route;

    // getProductDetails({
    //   productCode,
    //   activityCode,
    //   activityType,
    //   statusAll: true,
    //   withRecommend: false,
    //   disabledSoldOut: true
    // });

    this.$watch(
      'product.productCode',
      (val, oldVal) => {
        console.log('watch product.productCode');
        // 当前商品不可见
        if (!this.product.isAvailable) return;

        // 更新搜藏状态
        this.isLogin && !this.isGuest && this.product.productCode && this.queryWishStatus();

        // 优惠券
        this.queryCoupons();

        // 同步订阅状态
        this.syncSubscribeStatus();

        // 埋点
        this.trackView();

        // 穿搭推荐 延时调用
        this.$nextTick(() => {
          setTimeout(() => {
            this.lazyLoadFitRecommendFetched = false;
            window.addEventListener('scroll', this.lazyLoadFitRecommend);
          }, 500);
        });
      },
      { immediate: true }
    );

    // 超过最大可加购数量
    this.$eventBus.$on(
      'over-limit-click',
      ({ modifiers, over }) => modifiers.pdp && this.overLimitHandler(over)
    );

    // 埋点
    this.trackView();
  },
  updated() {
    // 初始化Pickup
    if (this.product.activedSizeAttr) {
      this.calcPickup(this.product.activedSizeAttr.skuNo);
    }
  },

  methods: {
    lazyLoadFitRecommend() {
      if (this.lazyLoadFitRecommendFetched) return;
      this.lazyLoadFitRecommendFetched = true;
      window.removeEventListener('scroll', this.lazyLoadFitRecommend);
      // 搭配商品
      this.queryPdtSet().finally(() => {
        this.$nextTick(() => {
          this.$refs.shortcut?.sync();
        });
      });
    },
    /**
     * 超过最大可加购数量
     */
    overLimitHandler(over = false) {
      this.$set(
        lo.find(this.product.pickupData.messages, { value: 'over-max-stock' }),
        'show',
        over
      );
    },

    /**
     * 加入会员
     */
    joinMember() {
      // 埋点
      this.$eventBus.$emit('LoginShow', { showLogin: true, showGuest: false });
    },

    /**
     * 切换商品
     */
    changePdt({ productNo: code }) {
      if (code === this.product.productNo) return;
      // 埋点
      this.trackSelectSizeAndColor(code);
      this.$nextTick(() => {
        this.$router.push({
          name: 'pdp',
          params: { code }
        });
      });
    },

    /**
     * 计算pickupData
     */
    calcPickup(skuNo) {
      const target = lo.find(this.product.sizeSaleAttrs, { skuNo });

      // if (this.product.activedSizeAttr && this.product.activedSizeAttr.skuNo === target.skuNo) {
      //   target = null;
      // }

      const outOfStock = target && target.availableQty === 0; // 无库存
      const max = outOfStock ? 1 : target?.realStock || 5;
      const { quantity: currQty, maxDangeStock } = this.product.pickupData;
      const willDangerStock = outOfStock ? false : target?.stock < maxDangeStock; // 库存紧张
      const salePrice = target?.salePrice || this.product.salePrice;
      const productPrice = target?.productPrice || this.product.productPrice;
      const skuCode = target?.skuCode || null;
      const quantity = outOfStock ? 1 : currQty > max ? max : currQty;

      this.$set(this.product.pickupData, 'max', max);
      this.$set(this.product.pickupData, 'quantity', quantity);
      this.$set(this.product.pickupData, 'salePrice', salePrice);
      this.$set(this.product.pickupData, 'productPrice', productPrice);
      this.$set(this.product.pickupData, 'skuCode', skuCode);
      this.$set(this.product.pickupData, 'outOfStock', outOfStock);

      this.$set(
        lo.find(this.product.pickupData.messages, { value: 'no-stock' }),
        'show',
        outOfStock
      );
      this.$set(
        lo.find(this.product.pickupData.messages, { value: 'danger-stock' }),
        'show',
        willDangerStock
      );
      this.$set(
        lo.find(this.product.pickupData.messages, { value: 'over-max-stock' }),
        'show',
        false
      );
    },

    /**
     * 切换尺码
     */
    changeSize(skuNo) {
      this.calcPickup(skuNo);
      const target = lo.find(this.product.sizeSaleAttrs, { skuNo });
      this.$set(this.product, 'activedSizeAttr', target);
      // 埋点
      this.trackSelectSizeAndColor();
    },

    /**
     * 增减数量
     */
    changeQuantity(quantity) {
      // 埋点
      const { max, min } = this.product.pickupData;

      if (quantity > max || quantity < min) return;

      this.$set(this.product.pickupData, 'quantity', quantity);
    },

    /**
     * 加购
     */
    async add2Cart() {
      try {
        this.$set(this.product.pickupData, 'pleasePickSize', false);
        this.$set(this.product.pickupData, 'loading', true);

        const pdp = useProduct();

        // Add to shop cart
        await pdp.gqlClient.mutate(addToCart, {
          input: {
            distributionType: 11,
            quantity: this.product.pickupData.quantity,
            ...lo.pick(this.product.activedSizeAttr, [
              'skuCode',
              'orgCode',
              'productCode',
              'activityCode',
              'activityType'
            ])
          }
        });

        // Toast
        GtMessage.success('已经成功加入购物袋');

        // 获取数量
        const res = await pdp.getMiniCartNum();
        this.$store.commit('setMiniCartNum', res);
        this.$store.commit('UPDATE_MINI_SHAPPING', { flag: true, title: '成功加入购物袋！' });

        this.trackDetailOperate({
          frame_name: '顶部商品参数区',
          click_type: '加入购物车'
        });
        this.loading = false;
      } catch (e) {
        console.error(e);
      } finally {
        this.$set(this.product.pickupData, 'loading', false);
      }
    },
    addToShopCart() {
      // 要素未填
      if (!this.product.activedSizeAttr) {
        GtMessage.error('请先选择尺码');
        this.$set(this.product.pickupData, 'pleasePickSize', true);
      }
      // 会员专享需要登录
      else if (this.product.isMemberOnly && (this.isGuest || !this.isLogin)) {
        this.$eventBus.$on('drawLoginSuccessCallback', this.add2Cart.bind(this));
        this.$eventBus.$emit('LoginShow', { showLogin: true, showGuest: false });
      }
      // 正常加购
      else {
        this.add2Cart();
      }
    },

    /**
     * 去购买
     */
    async toCheckout() {
      // 结算逻辑
      try {
        const { quantity } = this.product.pickupData;
        const shopCart = useUaShopCart({ distributionType: '11' });
        const data = await shopCart.checkOutCart({
          distributionType: '11',
          orgList: [
            {
              ...lo.pick(this.product, ['orgCode', 'storeCode']),
              products: [
                {
                  ...lo.pick(this.product.activedSizeAttr, ['productCode', 'skuCode']),
                  ...lo.pick(this.product, ['activityCode', 'activityType']),
                  quantity
                }
              ]
            }
          ]
        });

        // Cache into local
        const id = this.getCheckoutID(data);
        this.trackDetailOperate({
          frame_name: '顶部商品参数区',
          click_type: '立即购买'
        });
        this.$router.push({ name: 'checkout', params: { id } });
      } catch (e) {
        console.error(e);
      }
    },
    checkout() {
      // 未选尺码
      if (!this.product.activedSizeAttr) {
        GtMessage.error('请先选择尺码');
        this.$set(this.product.pickupData, 'pleasePickSize', true);
        return;
      }

      this.$set(this.product.pickupData, 'pleasePickSize', false);
      if (this.isGuest || !this.isLogin || !this.isCrm) {
        this.$eventBus.$on('drawLoginSuccessCallback', this.toCheckout.bind(this));
        this.$eventBus.$emit('LoginShow', {
          showLogin: true,
          showGuest: false,
          // 除了闷包，都要展示非会员入口
          showNonmember: !this.product.isBlindBox,
          refresh: false
        });
      } else {
        this.toCheckout();
      }
    },

    /**
     * 切换喜欢
     */
    async queryWishStatus() {
      const pdp = useProduct();
      const {
        data: { wishList = [] }
      } = await pdp.queryProductWishStatus(this.product.productCode);

      this.$set(this.product, 'isWish', wishList?.length > 0);
    },
    async toToggleWish() {
      const currentState = this.product.isWish;

      // 调用接口
      const pdp = useProduct();

      await pdp.changeProductWishStatus({
        productCode: this.product.productCode || '',
        wished: currentState
      });

      this.$set(this.product, 'isWish', !currentState);
      this.trackDetailOperate({
        frame_name: '顶部商品参数区',
        click_type: '收藏'
      });

      if (!currentState) {
        GtMessage.success('添加成功！可在“我的-喜欢”查看和管理哦');
      }
    },
    toggleWish() {
      // 未登录
      if (this.isGuest || !this.isLogin) {
        this.$eventBus.$on('drawLoginSuccessCallback', async () => {
          await this.queryWishStatus();

          const currentState = this.product.isWish;

          if (currentState) return;

          this.toToggleWish();
        });
        this.$eventBus.$emit('LoginShow', { showLogin: true, showGuest: false });
      } else {
        this.toToggleWish();
      }
    },

    /**
     * 联系客服
     */
    contactService() {
      const callback = () => {
        this.$customerService?.injectProduct(this.product.productCode, this.product.productName);
        this.$customerService?.open();
      };

      // 埋点
      if (!this.isGuest && this.isLogin) {
        callback();
      } else {
        this.$eventBus.$on('drawLoginSuccessCallback', callback);
        this.$eventBus.$emit('LoginShow', { showLogin: true, showGuest: true });
      }
    },

    /**
     * 查询套装商品
     */
    async queryPdtSet() {
      const pdp = getProduct();
      const data = await pdp.getRecommendProductList({
        productCode: this.product.productCode
      });
      this.$set(this.product, 'relationPdts', data);
    },

    /**
     * 查询订阅状态
     */
    async querySubscribeStatus({ businessCode, code = '' }, cb) {
      const pdp = getProduct();

      code = code || this.product.productNo;

      const list = await pdp.getSubscriptionMessage({
        businessCode
      });

      const hasSubscribe = !!lo.find(
        list,
        ({ businessCode: bc, code: codes = [] }) => bc === businessCode && lo.includes(codes, code)
      );

      typeof cb === 'function' && cb(hasSubscribe);

      return hasSubscribe;
    },

    // 同步订阅状态
    syncSubscribeStatus() {
      // 预热开售订阅状态
      this.isLogin &&
        !this.isGuest &&
        this.product.isHasPerHotActivity &&
        this.querySubscribeStatus(
          {
            businessCode: businessCodes.startSale
          },
          v => this.$set(this.subscription.sale, this.product.productNo, v)
        );

      // 到货订阅状态
      this.isLogin &&
        !this.isGuest &&
        !this.product.isStock &&
        this.querySubscribeStatus(
          {
            businessCode: businessCodes.spuOnStock
          },
          v => this.$set(this.subscription.stock, this.product.productNo, v)
        );
    },

    /**
     * 到货订阅
     */
    async subscribeStocking(cb) {
      // 未登录
      if (this.isGuest || !this.isLogin) {
        this.$eventBus.$on('drawLoginSuccessCallback', this.syncSubscribeStatus.bind(this));
        this.$eventBus.$emit('LoginShow', { showLogin: true, showGuest: false });
        return;
      }

      const pdp = getProduct();

      // 是否是sku维度
      const isSkuLevel = this.product.pickupData.outOfStock === true;
      const businessCode = isSkuLevel ? businessCodes.skuOnStock : businessCodes.spuOnStock;
      const code = isSkuLevel ? this.product.pickupData.skuCode : this.product.productNo;

      await pdp.subscriptionMessage({ businessCode, code });

      this.$set(this.subscription.stock, code, true);

      typeof cb === 'function' && cb();
    },

    // 预热开售订阅
    async subscribeSaling(cb) {
      // 未登录
      if (this.isGuest || !this.isLogin) {
        this.$eventBus.$on('drawLoginSuccessCallback', this.syncSubscribeStatus.bind(this));
        this.$eventBus.$emit('LoginShow', { showLogin: true, showGuest: false });
        return;
      }

      const pdp = getProduct();
      const code = this.product.productNo;

      await pdp.subscriptionMessage({
        businessCode: businessCodes.startSale,
        code
      });

      this.$set(this.subscription.sale, code, true);

      typeof cb === 'function' && cb();
    },

    /**
     * 优惠券
     */
    async queryCoupons() {
      const pdt = getProduct();

      const list = await pdt.queryCoupons({
        productCode: this.product.productCode
      });

      const coupons = lo
        .chain(list)
        .map(item => {
          const {
            activityBegin: validStartTime,
            activityEnd: validEndTime,
            activityName: name,
            activityLabel: tag,
            activityRemark: activityShortDesc
          } = item;
          return {
            name,
            tag,
            validStartTime,
            validEndTime,
            activityShortDesc,
            isPickupable: true,
            loading: false,
            ...item
          };
        })
        .value();

      this.$set(this.product, 'couponList', coupons);
    },
    pickupCoupon(data) {
      if (data.loading) return;

      const handler = async () => {
        try {
          this.$set(data, 'loading', true);
          const pdt = getProduct();

          await pdt.pickupCoupon({
            activityCode: data.activityCode,
            userCodes: getUserInfo().userCode,
            qty: 1
          });

          GtMessage.success('领取成功');
          this.$trackHelp.track('couponReceive', {
            belong_page: this.$route.meta.title,
            coupon_name: data.activityName,
            coupon_id: data.activityCode,
            coupon_amount: data.couponAmount || 0
          });
        } catch (err) {
          console.warn(err);
        } finally {
          this.$set(data, 'loading', false);
        }
      };

      // 未登录
      if (this.isGuest || !this.isLogin) {
        this.$eventBus.$on('drawLoginSuccessCallback', handler);
        this.$eventBus.$emit('LoginShow', { showLogin: true, showGuest: false });
      } else {
        handler();
      }
    },

    /**
     * Category
     */
    async queryCategories() {
      if (!this.product?.categories?.length) return;

      const pdt = getProduct();

      const list = await pdt.queryCategories(lo.map(this.product.categories, 'categoryCode'));

      this.$set(this.product, 'categories', list);
    },

    /**
     * Utils
     */
    toggleErrorTips(msg = '') {
      this.$set(this.product.pickupData, 'message', msg);
    },
    closeMiaoShaState() {
      this.$set(this.product, 'showMiaoshaPrice', false);
    },
    getCheckoutID(data) {
      const d = new Date();
      const id = Date.parse(d).toString();
      sessionStorage.setItem(id, JSON.stringify(data));
      return id;
    },
    trackView() {
      const previousPageData = this.$previousPage.getPreviousPageData();
      const basicInfo = this.getTrackBasicInfo();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio <= 0) return;
          const target = entry.target;
          // eslint-disable-next-line camelcase
          const frame_name = target.getAttribute('frame_name');
          this.$trackHelp.track('productDetailExpose', {
            ...previousPageData,
            ...basicInfo,
            frame_name,
            sku_id: this.product.productNo
          });
          observer.unobserve(target);
        });
      });
      const frameList = document.querySelectorAll('.pdp-track-container');
      [...frameList].forEach(item => {
        observer.observe(item);
      });

      this.$trackHelp.track('productDetailView', {
        ...previousPageData,
        ...basicInfo
      });
    },
    // eslint-disable-next-line camelcase
    trackDetailOperate({ frame_name, click_type }) {
      const previousPageData = this.$previousPage.getPreviousPageData();
      const basicInfo = this.getTrackBasicInfo();
      this.$trackHelp.track('DetailOperate', {
        sku_id: this.product.productNo,
        ...previousPageData,
        ...basicInfo,

        frame_name,
        click_type
      });
    },
    trackSelectSizeAndColor(code) {
      const previousPageData = this.$previousPage.getPreviousPageData();
      const basicInfo = this.getTrackBasicInfo();
      const item = (this.product.colorSaleAttrs || []).find(i => i.productNo === code);
      const missSize = this.product.sizeSaleAttrs.filter(item => item.disabled).map(i => i.label);
      this.$trackHelp.track('selectProductSpec', {
        sku_id: this.product.productNo,
        ...previousPageData,
        ...basicInfo,
        size: this.product?.activedSizeAttr?.label,
        color: item && item.fullAttrDisplayName,
        miss_size: missSize,
        miss_ratio: `${missSize.length}/${this.product.sizeSaleAttrs.length}`,
        destination_url: code ? `/p${code}.htm` : ''
      });
    },
    getTrackBasicInfo() {
      return {
        primary_category: this.product.length > 0 && this.product?.categories?.[0]?.categoryName, //	一级分类
        secondary_category: this.product?.categories[1]?.categoryName, //	二级分类
        third_category: this.product?.categories[2]?.categoryName, //	三级分类
        activity_attribute:
          (this.product?.productCornerLabel?.text && [this.product?.productCornerLabel?.text]) ||
          [],
        //	活动属性
        gender: this.product?.attributes?.PDP_SEX?.valueName, //	性别
        spu_id: this.product?.mainProductNo, //	spu_id
        spu_name: this.product?.productName, //	商品名称
        sales_price: Number(this.product?.salePrice), //	销售价
        list_price: Number(this.product?.productPrice), //	吊牌价
        is_discount: Number(this.product?.salePrice) < Number(this.product?.productPrice), //	是否打折款
        color: this.product?.activedColorAttr?.fullAttrDisplayName, //	颜色: 红色（002）
        size: this.product?.activedSizeAttr?.label //	尺码
      };
    }
  }
};
</script>

<style lang="scss" layput="pc" description="网页端样式">
.ua-pdp {
  position: relative;
  width: 100%;

  &-content {
    max-width: 1440px;
    width: 92%;
    margin: 0 auto;
    position: relative;
    padding-bottom: 120px;
  }

  &-pc-top-container {
    display: flex;
    align-items: flex-start;
    position: relative;
    margin-bottom: 28px;
  }

  &-pc-imgs {
    position: sticky;
    top: 100px;
    width: 68.7%;
    padding-right: 3.3%;
  }

  &-pc-sale-attrs {
    width: 28%;
    background: #fff;
  }

  &-btm-block {
    overflow: visible;
  }
}

.ua-pdp-topAd-container__mobile {
  // margin: 20px 0 0 0;
  margin-bottom: -8px;
  .ua-section-box__content {
    padding: 20px 20px 0 20px;
  }
}
// pdp 全局抽屉样式重置
.ua-pdp-drawer--mb {
  header#el-drawer__title {
    margin-bottom: 22px;

    span[role='heading'] {
      font-size: 16px;
      font-weight: 600;
    }
  }
}

.ua-pdp-drawer--pc {
  header#el-drawer__title {
    margin-bottom: 22px;
    padding: 20px 20px 0px 40px;

    span[role='heading'] {
      font-size: 22px;
      font-weight: 600;
    }
  }

  .el-drawer__close-btn {
    font-size: 24px;
    transform: translateY(-2px);
  }
}
</style>

<style lang="scss" layput="mobile" description="移动端样式">
.page-layout_mobile .ua-pdp {
  &-content {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    padding-bottom: 32px;
  }

  &-btm-block {
    padding-bottom: 0px;
  }
}
</style>
